
import { formatPrice } from '../hooks/contractHelper';
import { useHeaderStats } from '../stats/useStats';
import Connect from './Connect';
import { api, NFT_SYMBOL } from '../hooks/constant';
import CurrencyExchangeIcon from '@mui/icons-material/CurrencyExchange';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import GeneratingTokensIcon from '@mui/icons-material/GeneratingTokens';
import { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Header({ purchaseStats, categoryId }) {
    const location = useLocation();
    const currentPath = location.pathname;
    const headStats = useHeaderStats(1);
    const [statics, setStatics] = useState({
        total_nfts: 0,
        total_sold: 0,
        total_left: 0,
        total_usdt: 0,
        total_volume: 0,
    })

    useEffect(() => {
        async function fetch() {
            const response = await api.post('get_category_statics', {
                "category_id": categoryId?.id
            });

            if (response && response.data) {
                setStatics(response.data);
            }
        }

        fetch();
    }, [categoryId?.id]);


    // useEffect(() => {
    //     async function fetch() {
    //         const response = await api.get('get_statics')

    //         if (response && response.data && response.data) {
    //             setStatics(response.data)
    //         }
    //     }

    //     fetch()
    // }, []);

    return (
        <section class="tf-section tf-explore tf-filter mx-auto">
            <div class="rounded-md text-card-foreground overflow-hidden border-none backdrop-blur-sm">
                <div class="p-4 sm:p-6">
                    <div class="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 sm:gap-4 mb-4 sm:mb-6">
                        <div className='gap-2 md:flex items-center text-center'>
                            <Link to="/">
                                <h5 class="logo-heading-text font-bold">MGP NFT Lotto</h5>
                                <p class="text-sm text-muted-foreground mb-2 md:mb-0">Get rewards every 16 days with MGP</p>
                            </Link>
                            <Link
                                to="/"
                                className={`nav-link-text first-nav-text ${currentPath === '/' ? 'active' : ''}`}
                            >
                                Home
                            </Link>

                            <Link
                                to="/my-nft"
                                className={`nav-link-text ${currentPath === '/my-nft' ? 'active' : ''
                                    }`}
                            >
                                My NFTs
                            </Link>

                            <Link
                                to="/staked"
                                className={`nav-link-text ${currentPath === '/staked' ? 'active' : ''
                                    }`}
                            >
                                Staked NFTs
                            </Link>
                        </div>

                        <div className='mt-3 md:mt-0'>
                            <div class="gap-2 balance-wrap flex md:gap-0 justify-content-center">
                                <Link to="/my-nft" class="header-balance d-none d-md-block">
                                    <div class="btn-balance-wrap">
                                        <div class="balance-title">Your Lotto:</div>
                                        <div class="balance active">
                                            <div>{headStats.NFTBalance ? formatPrice(headStats.NFTBalance) : 0} {NFT_SYMBOL}</div>
                                        </div>
                                    </div>
                                </Link>
                                <button class="header-balance">
                                    <div class="btn-balance-wrap">
                                        <div class="balance-title">Wallet Balance:</div>
                                        <div class="balance active">
                                            <div>{headStats.tokenBalance ? formatPrice(headStats.tokenBalance) : 0} MCOIN</div>
                                            <div>{headStats.ethBalance ? formatPrice(headStats.ethBalance) : 0} BNB</div>
                                        </div>
                                    </div>
                                </button>
                                <Connect
                                    className="px-3 w-full sm:w-auto transition-all duration-200 connect-btn btn btn-connect"
                                />
                            </div>

                        </div>


                    </div>
                    <div class="grid grid-cols-1 gap-3 sm:grid-cols-2 md:grid-cols-4 sm:gap-4">
                        <div>
                            <div class="relative overflow-hidden rounded-xl sc-product p-4 sm:p-6 shadow-md hover:shadow-lg transition-shadow duration-200">
                                <div class="absolute top-[-20px] right-[-20px] w-16 sm:w-20 h-16 sm:h-20 -mr-6 -mt-6 opacity-10"><div class="w-full h-full rounded-full bg-blue-500"></div></div>
                                <div class="flex items-center mb-2">
                                    <div class="p-1.5 sm:p-2 rounded-lg bg-opacity-10 mr-2 sm:mr-3">
                                        <CurrencyExchangeIcon />

                                    </div>
                                    <span class="text-xs sm:text-sm text-muted-foreground">Sale Amount</span>
                                </div>
                                <div class="flex items-baseline">
                                    <h5 class="text-lg sm:text-2xl font-bold">{statics.total_volume ? formatPrice(statics.total_volume) : 0} MCOIN</h5>
                                </div>
                            </div>
                        </div>
                        <div >
                            <div class="relative overflow-hidden rounded-xl sc-product p-4 sm:p-6 shadow-md hover:shadow-lg transition-shadow duration-200">
                                <div class="absolute top-[-20px] right-[-20px] w-16 sm:w-20 h-16 sm:h-20 -mr-6 -mt-6 opacity-10"><div class="w-full h-full rounded-full bg-blue-500"></div></div>
                                <div class="flex items-center mb-2">
                                    <div class="p-1.5 sm:p-2 rounded-lg bg-opacity-10 mr-2 sm:mr-3">
                                        <CurrencyExchangeIcon />

                                    </div>
                                    <span class="text-xs sm:text-sm text-muted-foreground">Sale Amount</span>
                                </div>
                                <div class="flex items-baseline">
                                    <h5 class="text-lg sm:text-2xl font-bold">{statics.total_usdt ? formatPrice(statics.total_usdt) : 0} USDT</h5>
                                </div>
                            </div>
                        </div>
                        <div >
                            <div class="relative overflow-hidden rounded-xl  sc-product  p-4 sm:p-6 shadow-md hover:shadow-lg transition-shadow duration-200">
                                <div class="absolute top-[-20px] right-[-20px] w-16 sm:w-20 h-16 sm:h-20 -mr-6 -mt-6 opacity-10"><div class="w-full h-full rounded-full bg-green-500"></div></div>
                                <div class="flex items-center mb-2">
                                    <div class="p-1.5 sm:p-2 rounded-lg bg-opacity-10 mr-2 sm:mr-3">
                                        <AccountBalanceWalletIcon />
                                    </div>
                                    <span class="text-xs sm:text-sm text-muted-foreground">Lotto Amount</span>
                                </div>
                                <div class="flex items-baseline">
                                    <h5 class="text-xl sm:text-xl font-bold">
                                        {statics.total_nfts ? formatPrice(statics.total_nfts) : 0}
                                    </h5>
                                </div>
                            </div>
                        </div>
                        <div >
                            <div class="relative overflow-hidden rounded-xl sc-product p-4 sm:p-6 shadow-md hover:shadow-lg transition-shadow duration-200">
                                <div class="absolute top-[-20px] right-[-20px] w-16 sm:w-20 h-16 sm:h-20 -mr-6 -mt-6 opacity-10"><div class="w-full h-full rounded-full bg-purple-500"></div></div>
                                <div class="flex items-center mb-2">
                                    <div class="p-1.5 sm:p-2 rounded-lg bg-opacity-10 mr-2 sm:mr-3">
                                        <GeneratingTokensIcon />

                                    </div>
                                    <span class="text-xs sm:text-sm text-muted-foreground">Lotto Balance</span>
                                </div>
                                <div class="flex items-baseline">
                                    <h5 class="text-lg sm:text-2xl font-bold">
                                        {statics.total_left ? formatPrice(statics.total_left) : 0}
                                    </h5>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </section>
    )
}
